import Box from "@mui/material/Box";
import BreadCrumb from "app/components/BreadCrumb";
import AddOrderModal from "app/containers/CommonModal/AddOrderModal";
import { addOrderModalActions } from "app/containers/CommonModal/redux/slice";
import { AddOrderModalContext } from "app/containers/CommonModal/types";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import ActionBar from "./components/ActionBar";
import WorkOrderTable from "./components/WorkOrderTable";
import {
  selectFilteredWorkOrders,
  selectWorkOrderLoading,
} from "./redux/selector";
import { reducer, sliceKey } from "./redux/slice";
import { workOrderSaga } from "./redux/saga";
import { useStyles } from "./styles";

const WorkOrder = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });
  useInjectSaga({ key: sliceKey, saga: workOrderSaga });

  const rows = useSelector(selectFilteredWorkOrders);
  const loading = useSelector(selectWorkOrderLoading);

  return (
    <Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <Box className={styles.pageContent}>
            <BreadCrumb title={t("SIDEBAR.WORK_ORDERS")} iconPosition="end" />
            <ActionBar
              onAddClick={() =>
                dispatch(
                  addOrderModalActions.openAddOrderModal({
                    context: AddOrderModalContext.WORK_ORDER,
                  })
                )
              }
            />
            <WorkOrderTable rows={rows} loading={loading} />
          </Box>
        </Box>
        <AddOrderModal titleKey="WORK_ORDER.MODAL.ADD_TITLE" />
    </Box>
  );
};

export default WorkOrder;
